<!--  -->
<template>
  <div>
<!--======================================
        START FEATURE AREA
  ======================================-->
  <section class="feature-area text-center">
      <div class="container">
          <div class="row feature-content-wrap">
              <div class="col-lg-4 col-sm-6">
                  <div class="feature-item feature-item1" @click="$router.push(`/views/${plateid}`)">
                    <img src="/static/images/icon_1.1.png" class="mings">
                      <h3 class="feature__title">名师简介</h3>
                      <p class="feature__text">全国名校名师信息介绍</p>
                  </div><!-- end feature-item -->
              </div><!-- end col-lg-3 -->
              
              <div class="col-lg-4 col-sm-6">
                  <div class="feature-item feature-item3" @click="$router.push(`/kscx`)">
                      <img src="/static/images/icon_3.png" class="shij">
                      <h3 class="feature__title">成绩查询</h3>
                      <p class="feature__text">输入学号查询考试成绩</p>
                  </div><!-- end feature-item -->
              </div><!-- end col-lg-3 -->
              <div class="col-lg-4 col-sm-6">
                  <div class="feature-item feature-item2" @click="$router.push(`/courviews`)">
                    <img src="/static/images/icon_2.png" class="kec">
                      <h3 class="feature__title">课程简介</h3>
                      <p class="feature__text">高质量课程在线视频</p>
                  </div><!-- end feature-item -->
              </div><!-- end col-lg-3 -->
          </div><!-- end row -->
      </div><!-- end container -->
  </section><!-- end feature-area -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        plateid:"",
        global
    };
  },
  props: {
    plates:Array
  },
  components: {},

  computed: {},

  mounted() {
    for (var i = 0; i < this.plates.length; i++) {
        if(this.plates[i].name=="名师简介"){
            this.plateid = this.plates[i]._id;
        }
    }
  },
  methods: {

  }
}

</script>
<style scoped>
</style>